/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TValidateVisibleViolationsModel,
  IMappers,
  IValidateVisibleViolationsResponseError,
  TValidateVisibleViolationsResponse,
  IValidateVisibleViolationsRequest,
} from './types';

const defaultConfig: TValidateVisibleViolationsModel = {
  apiType: 'legacy',
  assertStatusCodes: [204, 400],
  method: 'POST',
  microserviceName: 'monolith-python',
  pathApi: `/addform/v2/validate-visible-violations/`,
  hostType: 'api',
} as TValidateVisibleViolationsModel;

function createValidateVisibleViolationsModel(
  parameters: IValidateVisibleViolationsRequest,
): TValidateVisibleViolationsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IValidateVisibleViolationsOptions<TResponse204, TResponse400> {
  httpApi: IHttpApi;
  parameters: IValidateVisibleViolationsRequest;
  config: IHttpApiFetchConfig;
  mappers: IMappers<TResponse204, TResponse400>;
}

async function fetchValidateVisibleViolations<TResponse204, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IValidateVisibleViolationsOptions<TResponse204, TResponse400>): Promise<
  TResponse204 | TResponse400 | TValidateVisibleViolationsResponse
> {
  const { response, headers, statusCode } = await httpApi.fetch(
    createValidateVisibleViolationsModel(parameters),
    config,
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 204) {
      return mappers[204]();
    }

    if (statusCode === 400) {
      return mappers[400](response as IValidateVisibleViolationsResponseError, headers);
    }
  }

  return { response, statusCode } as TValidateVisibleViolationsResponse;
}

export { defaultConfig, createValidateVisibleViolationsModel, fetchValidateVisibleViolations };
